import { useGetPriceInvisibilityRulesQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import {
    priceInvisibilityRulesColumns,
    type PriceInvisibilityRuleRow,
} from '../constants/priceInvisibilityRulesColumns';

export const PriceInvisibilityRulesList = () => {
    const { loading, data, error } = useGetPriceInvisibilityRulesQuery();

    if (loading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!data || error) {
        throw new Error("Une erreur est survenue lors de la récupération des règles d'invisibilité des prix");
    }

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<PriceInvisibilityRuleRow>
                columns={priceInvisibilityRulesColumns}
                data={data.priceInvisibilityRules}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/price-invisibility-rule/${row._id}`}
                searchPlaceholder="Nom de la règle"
            />
        </div>
    );
};
